// sets form as complete

const StepProgressionActions = {
  ENABLE_PROGRESSION: 'StepProgression.SET_ENABLED',
  DISABLE_PROGRESSION: 'StepProgression.SET_DISABLE',
};

export default StepProgressionActions;
